export default __webpack_public_path__ + "static/media/1.108a90fc.png";